import { z } from "zod";

import { myvPlanningModeDtoSchema } from "./planning-mode-dto";

export const myvScheduleDtoSchema = z.object({
  on: z.boolean(),
  planningMode: myvPlanningModeDtoSchema,
  temperature: z.number().nullable(),
  timeEnd: z.string(),
  timeStart: z.string(),
});

export const myvPlanningScheduleDtoSchema = z.object({
  active: z.boolean(),
  day: z.number(),
  schedule: z.array(myvScheduleDtoSchema).nullable(),
});

export const myvPlanningDtoSchema = z.object({
  csLinkId: z.number(),
  serialNumber: z.string().nullable(),
  technicianLocalisationDeclaration: z.string().nullable(),
  userLocalisationDeclaration: z.string().nullable(),
  myVPlanningSchedules: z.array(myvPlanningScheduleDtoSchema).nullable(),
});

export type TMyVPlanningDto = z.infer<typeof myvPlanningDtoSchema>;
export type TMyVPlanningScheduleDto = z.infer<typeof myvPlanningScheduleDtoSchema>;
export type TMyVScheduleDto = z.infer<typeof myvScheduleDtoSchema>;
